import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4a67e08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "more-info-list" }
const _hoisted_2 = { class: "more-info-list" }
const _hoisted_3 = {
  key: 0,
  class: "more-info-list"
}
const _hoisted_4 = {
  key: 1,
  class: "more-info__footer"
}

import { computed, watch } from 'vue'
import { useStore } from 'vuex'
import { isAndroidNative, isIOSNative } from '@xunlei/universal-native-api'
import Page from '@remote/components/layout/SubPage.vue'
import MoreInfoItem from '@remote/components/MoreInfoItem.vue'
import { toast } from '@remote/utils/index'
import { useEnvStore } from '@remote/store/env'
import router from '@remote/router'
import { isLargeViewPort as checkViewPort } from '@remote/utils/base'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isLargeViewPort = checkViewPort()

const store = useStore()
const envStore = useEnvStore()

const action = computed(() => {
  return store.state.action
})

const isLogoutHide = computed(() => {
  return envStore.isInPC || isAndroidNative || isLargeViewPort
})

const isInXunlei = computed(() => {
  return envStore.isInPC || isAndroidNative || isIOSNative
})
const logout = (isLogout) => {
  if (isAndroidNative || isIOSNative) {
    toast('请在迅雷客户端中退出登录，或在设备列表中解绑设备')
    return
  }
  store.dispatch('logout', isLogout)
}

watch(action, (val) => {
  if (val === 'logout') {
    logout(true)
  }
})

const goTransmissionSettings = () => {
  router.push({
    name: 'transmissionSettings',
    query: router.currentRoute.value.query,
  })
}

const goServiceSettings = () => {
  router.push({
    name: 'serviceSettings',
    query: router.currentRoute.value.query,
  })
}

const goAbout = () => {
  router.push({
    name: 'about',
    query: router.currentRoute.value.query,
  })
}

const goAccountSettings = () => {
  router.push({
    name: 'accountSettings',
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Page, {
    title: _unref(isLargeViewPort) ? '设置' : '更多'
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(MoreInfoItem, {
          title: "账号与安全",
          onClick: goAccountSettings
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(MoreInfoItem, {
          title: "传输设置",
          onClick: goTransmissionSettings,
          "has-bottom-line": ""
        }),
        _createVNode(MoreInfoItem, {
          title: "服务设置",
          onClick: goServiceSettings
        })
      ]),
      (_unref(isInXunlei))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(MoreInfoItem, {
              title: "关于迅雷",
              onClick: goAbout
            })
          ]))
        : _createCommentVNode("", true),
      (!_unref(isLogoutHide))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "more-info__logout",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (logout(false)))
            }, " 退出登录 ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})